/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs */

const en_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust Duration to Reading Speed`)
};

const fr_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster la duree a la vitesse de lecture`)
};

const de_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer an Lesegeschwindigkeit anpassen`)
};

const it_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta la durata alla velocità di lettura`)
};

const ru_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте продолжительность чтения в соответствии со скоростью чтения.`)
};

const es_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar la duración a la velocidad de lectura`)
};

const zh_cn2_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据阅读速度调整阅读时长`)
};

const ja_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読む速度に合わせて期間を調整する`)
};

const hi_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पढ़ने की गति के अनुसार अवधि समायोजित करें`)
};

const pt_pt2_shortcut_keys_name_adjust_duration_reading_speed = /** @type {(inputs: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste a duração à velocidade de leitura.`)
};

/**
* | output |
* | --- |
* | "Adjust Duration to Reading Speed" |
*
* @param {Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_adjust_duration_reading_speed = /** @type {((inputs?: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "de") return de_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "it") return it_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "es") return es_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_adjust_duration_reading_speed(inputs)
	return en_shortcut_keys_name_adjust_duration_reading_speed(inputs)
});